<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Manage Users</h1>
          <div class="has-text-right">
            <b-button
              type="is-primary"
              icon-left="plus"
              tag="router-link"
              :to="{ name: 'CreateUser' }"
              >Add User</b-button
            >
          </div>
          <b-field class="has-margin-top-15">
            <b-input
              v-model="search"
              placeholder="Search..."
              type="search"
              icon="magnify"
            >
            </b-input>
          </b-field>
          <b-table
            :data="filteredUsers"
            :bordered="false"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            :loading="loading"
            :focusable="false"
            :mobile-cards="true"
            :paginated="true"
          >
            <template slot-scope="props">
              <b-table-column field="company" label="Company">
                <div class="has-margin-top-5 has-margin-bottom-5">
                  <span class="has-text-weight-bold">{{
                    props.row.company
                  }}</span
                  ><br />
                  {{ props.row.first_name }} {{ props.row.last_name }}<br />
                  <a :href="`mailto:${props.row.email}`" target="_blank">{{
                    props.row.email
                  }}</a
                  ><br />
                  <a :href="`tel:${props.row.phone}`" target="_blank">{{
                    props.row.phone
                  }}</a>
                </div>
              </b-table-column>

              <b-table-column field="role" label="Roles">
                <div v-if="props.row.role && props.row.role.length > 0">
                  <b-tag
                    v-for="role in props.row.role.split(',')"
                    :key="role"
                    class="has-margin-right-5"
                    >{{ role }}</b-tag
                  >
                </div>
              </b-table-column>

              <b-table-column field="verified" label="Verified">
                {{ isVerified(props.row) ? 'Yes' : 'No' }}
                <a href="" @click.prevent="verify(props.row)">
                  <b-icon
                    v-if="!isVerified(props.row)"
                    icon="toggle-switch-off"
                  ></b-icon>
                </a>
              </b-table-column>

              <b-table-column field="is_read_only" label="Read Only">
                <b-tag v-if="isReadOnly(props.row)" type="is-warning">Yes</b-tag>
                <span v-else>No</span>
              </b-table-column>

              <b-table-column label="">
                <b-dropdown aria-role="list">
                  <button slot="trigger" class="button is-primary">
                    <span>Actions</span>
                    <b-icon icon="menu-down"></b-icon>
                  </button>

                  <b-dropdown-item aria-role="listitem" :has-link="true"
                    ><router-link
                      :to="{
                        name: 'UpdateUser',
                        params: { id: props.row.id }
                      }"
                      >Edit</router-link
                    ></b-dropdown-item
                  >
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="changeAdmin(props.row)"
                    >{{
                      props.row.role.includes('admin')
                        ? 'Revoke Admin Access'
                        : 'Make Admin'
                    }}</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="!isSelf(props.row)"
                    aria-role="listitem"
                    @click="changeReadOnly(props.row)"
                    >{{
                      isReadOnly(props.row)
                        ? 'Remove Read-Only'
                        : 'Make Read-Only'
                    }}</b-dropdown-item
                  >
                </b-dropdown>
              </b-table-column>
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-medium"> </b-icon>
                  </p>
                  <p>No users yet.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </CardComponent>
    </section>
    <!-- <b-modal
      :active.sync="showConfirmModal"
      trap-focus
      aria-role="dialog"
      aria-modal
      has-modal-card
      @close="showConfirmModal = false"
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirm Delete?</p>
        </header>
        <section class="modal-card-body">
          Are you sure you want to delete this user?
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <button
            class="button"
            type="button"
            @click="showConfirmModal = false"
          >
            No
          </button>
          <button class="button is-primary" @click.prevent="deleteTitle()">
            Yes
          </button>
        </footer>
      </div>
    </b-modal> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
import UserApi from '@/api/user'
import axios from '@/axios'

export default {
  name: 'ManageUsers',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Manage Users'
  },
  computed: {
    ...mapGetters(['user']),
    filteredUsers() {
      if (this.search !== '' && this.users.length > 0) {
        let query = this.search.toLowerCase()
        return this.users.filter(
          item =>
            item.first_name.toLowerCase().includes(query) ||
            item.last_name.toLowerCase().includes(query) ||
            item.company.toLowerCase().includes(query) ||
            item.job_title.toLowerCase().includes(query) ||
            item.role.toLowerCase().includes(query)
        )
      } else {
        return this.users
      }
    }
  },
  created() {
    this.fetchUsers()
  },
  data() {
    return {
      loading: true,
      users: [],
      search: '',
      axios: axios
      // showConfirmModal: false,
      // item: {}
    }
  },
  methods: {
    ...mapActions(['getUser']),
    isVerified(item) {
      return item && item.verified === 1
    },
    isReadOnly(item) {
      // MySQL returns tinyint as number; coerce defensively (see Issue 54)
      return item && (item.is_read_only === 1 || item.is_read_only === true)
    },
    isSelf(item) {
      return item && this.user && String(item.id) === String(this.user.id)
    },
    changeReadOnly(item) {
      if (this.isSelf(item)) {
        this.$buefy.toast.open({
          message: 'You cannot change your own read-only status',
          position: 'is-top',
          type: 'is-danger'
        })
        return
      }
      const newValue = !this.isReadOnly(item)
      this.$buefy.dialog.confirm({
        title: newValue ? 'Make user read-only?' : 'Remove read-only?',
        message: newValue
          ? `<b>${item.email}</b> will be able to browse the system but all create/edit/delete actions will be blocked with a 403 error.`
          : `<b>${item.email}</b> will regain full write access for their assigned role.`,
        confirmText: 'Yes, apply',
        type: newValue ? 'is-warning' : 'is-info',
        onConfirm: () => {
          UserApi.adminUpdate({
            id: item.id,
            is_read_only: newValue
          })
            .then(() => {
              this.$buefy.toast.open({
                message: newValue
                  ? 'User set to read-only. They must log out and back in for the change to take effect.'
                  : 'Read-only removed. User must log out and back in.',
                position: 'is-top',
                type: 'is-success',
                duration: 5000
              })
              this.fetchUsers()
            })
            .catch(err => {
              console.log(err)
              this.$buefy.toast.open({
                message: 'Error changing read-only status',
                position: 'is-top',
                type: 'is-danger'
              })
            })
        }
      })
    },
    verify(item) {
      let updateObject = {
        id: item.id
      }
      updateObject.verified = item.verified === 1 ? false : true
      UserApi.adminUpdate(updateObject)
        .then(() => {
          this.$buefy.toast.open({
            message: 'User verified status changed successfully!',
            position: 'is-top',
            type: 'is-success'
          })
          this.fetchUsers()
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error changing user verified status',
            position: 'is-top',
            type: 'is-danger'
          })
        })
    },
    changeAdmin(item) {
      let roles = item.role.split(',')
      if (roles.includes('admin')) {
        roles = roles.filter(role => role !== 'admin')
      } else {
        roles.push('admin')
      }
      UserApi.adminUpdate({
        id: item.id,
        role: roles
      })
        .then(() => {
          this.$buefy.toast.open({
            message: 'Change role successfully',
            position: 'is-top',
            type: 'is-success'
          })
          this.fetchUsers()
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error changing role',
            position: 'is-top',
            type: 'is-danger'
          })
        })
    },
    fetchUsers() {
      this.loading = true
      if (!this.$route.params.id) {
        UserApi.getAll().then(users => {
          this.users = users
          this.loading = false
        })
      } else {
        UserApi.getAllByOrganisation(this.$route.params.id).then(users => {
          this.users = users
          this.loading = false
        })
      }
    }
  }
}
</script>
